import { apiClientV2 } from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_ORDER_URL

const _get = async (queryParamFilters, queryParam, setParams, setMetadata) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: queryParamFilters || undefined,
  }

  setParams?.(params)

  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/delivery-order-request',
    params: params,
  })

  setMetadata?.(response?.data.metadata)

  return response?.data
}

export const get = (queryParamFilters, setParams, setMetadata) => async (queryParam) =>
  await _get(queryParamFilters, queryParam, setParams, setMetadata)

export const show = async (id) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/delivery-order-request/${id}`,
  })

  return response?.data
}

export const _getLoad = async (id, queryParam) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
  }

  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/delivery-order-request/${id}/load`,
    params: params,
  })

  return response?.data
}

export const getLoad = (id) => async (queryParam) => await _getLoad(id, queryParam)

export const transition = async (id, data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: `/delivery-order-request/${id}/transition`,
    data,
  })

  return response?.data
}